/**
 * @description Function to serialize digital filters JSON into query string. Used in  ProductList component
 * @private
 * @params string
 * @returns string
 */

export function serializeDigitalFilters(digitalFiltersObject) {
  const filters = Object.entries(digitalFiltersObject).reduce((acc, [filterKey, filterValue]) => {
    if (filterKey === 'text') {
      const trimmedValue = filterValue.trim().replace(/\s+/g, ' ').replace(/ /g, ',');
      return acc + `&${filterKey}=` + trimmedValue;
    }
    if (filterValue.length > 1 && typeof filterValue === 'object') {
      return acc + filterValue.reduce((accumulator, value) => accumulator + `&filter.${filterKey}[]=` + value, '');
    }
    return acc + `&filter.${filterKey}[]=` + filterValue;
  }, '');
  return filters.escape();
}

String.prototype.escape = function () {
  const tagsToReplace = {
    '<': '%3C',
    '>': '%3E',
  };
  return this.replace(/[&<>]/g, function (tag) {
    return tagsToReplace[tag] || tag;
  });
};
